export default __webpack_public_path__ + "static/media/nuwave_black.c0279581.png";